import React from 'react';

export default function DayraLogo({ className = '', height = 32, variant = 'default' }) {
  return (
    <img
      src="/dayra-logo.svg"
      alt="Dayra"
      height={height}
      className={`${className}`}
      style={{ height, width: 'auto' }}
    />
  );
}
